export enum RelationshipsEnum {
  NONE = 0,
  PARTNER = 1,
  PARENT = 2,
  SIBLING = 3,
  OFFSPRING = 4,
  OTHER = 5,
}
